import React, { useEffect } from 'react';
import userInfoApi from '../../api/UserInfoApi';

interface User {
  isAuthenticated: boolean;
}

interface AuthContextType {
  user: User | undefined;
}

const AuthContext = React.createContext<AuthContextType>({ user: undefined });

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = React.useState<User | undefined>(undefined);

  useEffect(() => {
    userInfoApi.fetch().then((data) => {
      if (!data) return setUser({ isAuthenticated: true });
      setUser({ isAuthenticated: false });
    });
  }, []);

  const value = { user };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthProvider, AuthContext };
export type { User, AuthContextType };
